<script>
import HeroHeader from '@/components/HeroHeader.vue'
import Stepper from '@/components/Stepper.vue'
import FormCard from '@/components/FormCard.vue'
import EtapaVendedor from '@/steps/EtapaVendedor.vue'
import EtapaPdf from '@/steps/EtapaPdf.vue'
import EtapaSimulacao from '@/steps/EtapaSimulacao.vue'
import EtapaDadosPessoais from '@/steps/EtapaDadosPessoais.vue'
import EtapaInstalacao from '@/steps/EtapaInstalacao.vue'
import EtapaDocumento from '@/steps/EtapaDocumento.vue'
import EtapaRevisao from '@/steps/EtapaRevisao.vue'
import { CONCESSIONARIAS, carregarConcessionarias } from '@/data/concessionarias'
import { api } from '@/services/api'
import { getStoredSponsor, setStoredSponsor, clearStoredSponsor } from '@/utils/sponsor'
import { gerarResumoSimulacao } from '@/utils/simulador'

export default {
  components: {
    HeroHeader, Stepper, FormCard,
    EtapaVendedor, EtapaPdf, EtapaSimulacao, EtapaDadosPessoais, EtapaInstalacao, EtapaDocumento, EtapaRevisao,
  },

  data() {
    return {
      etapaAtual: 1,
      etapasConcluidas: [],
      etapas: [
        { numero: 1, label: 'Vendedor' },
        { numero: 2, label: 'Conta' },
        { numero: 3, label: 'Simulação' },
        { numero: 4, label: 'Dados' },
        { numero: 5, label: 'Instalação' },
        { numero: 6, label: 'Documento' },
        { numero: 7, label: 'Revisão' },
      ],

      sponsor: null,

      pdfFile: null,
      extractedJson: null,
      concessionariaNaoIdentificada: '',
      modoManual: false,

      docFront: null,
      docBack: null,

      enviando: false,
      honeypot: '',

      form: {
        person_type: 'pf',
        person_number: '',
        nome: '',
        telefone: '',
        email: '',
        data_nascimento: '',
        nacionalidade: 'Brasileira',
        estado_civil: 'solteiro',

        concessionaria_id: '',
        tipo_fase: '',
        numero_instalacao: '',
        kwh_avg: '',
        mes_referencia: '',
        valor_fatura: '',

        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        obs_instalacao: '',

        tipo_documento: 'cnh',
      },
    }
  },

  computed: {
    tituloEtapa() {
      const map = {
        1: 'Quem é o seu vendedor?',
        2: 'Envie o arquivo da sua conta de energia',
        3: this.modoManual ? 'Informe os dados da sua conta' : 'Veja quanto você pode economizar',
        4: 'Conte um pouco sobre você',
        5: 'Detalhes da sua instalação',
        6: 'Documento de identidade',
        7: 'Revise antes de enviar',
      }
      return map[this.etapaAtual] || ''
    },
    subtituloEtapa() {
      const map = {
        1: 'Informe o código do vendedor que te indicou',
        2: 'Vamos preencher os dados da sua conta automaticamente.',
        3: this.modoManual ? 'Preencha os dados abaixo para simular sua economia.' : 'Estimativa de economia com o Clube Solar AXEN, com base na sua fatura.',
        4: 'Esses dados ficam protegidos e são usados apenas para o cadastro.',
        5: 'Endereço e dados da sua ligação de energia.',
        6: 'Anexe sua CNH ou RG para validação.',
        7: '',
      }
      return map[this.etapaAtual] || ''
    },
  },

  created() {
    carregarConcessionarias().catch(() => {
      this.$toast.error('Não foi possível carregar as concessionárias. Recarregue a página.')
    })

    // Vendedor já resolvido pelo link /:username — definido antes do render
    // para que a etapa 1 já nasça com o campo de código preenchido
    const stored = getStoredSponsor()
    if (stored && stored.indication) {
      this.sponsor = stored
    }
  },

  methods: {
    nomeConcessionaria() {
      const c = CONCESSIONARIAS.find(x => String(x.id) === String(this.form.concessionaria_id))
      return c ? c.nome : ''
    },

    marcarConcluida(n) {
      if (!this.etapasConcluidas.includes(n)) this.etapasConcluidas.push(n)
    },

    irParaEtapa(n) {
      if (this.etapasConcluidas.includes(n) || n === this.etapaAtual) {
        this.etapaAtual = n
      }
    },

    resetDadosExtraidos() {
      this.extractedJson = null
      this.concessionariaNaoIdentificada = ''
      this.modoManual = false
      this.form.concessionaria_id = ''
      this.form.tipo_fase = ''
      this.form.numero_instalacao = ''
      this.form.kwh_avg = ''
      this.form.mes_referencia = ''
      this.form.valor_fatura = ''
      this.form.nome = ''
      this.form.person_number = ''
      this.form.cep = ''
      this.form.logradouro = ''
      this.form.numero = ''
      this.form.complemento = ''
      this.form.bairro = ''
      this.form.cidade = ''
      this.form.estado = ''
    },

    onSponsorConfirmado(user) {
      this.sponsor = user
      setStoredSponsor(user)
      this.marcarConcluida(1)
      this.etapaAtual = 2
    },
    onSponsorIgnorado() {
      // Limpa qualquer vendedor antigo para que ele não seja reaplicado neste cadastro
      this.sponsor = null
      clearStoredSponsor()
      this.marcarConcluida(1)
      this.etapaAtual = 2
    },

    onPdfFile(file) {
      this.pdfFile = file
      if (file) this.resetDadosExtraidos()
    },
    onModoManual() {
      this.modoManual = true
      this.marcarConcluida(2)
      this.etapaAtual = 3
    },
    onDocFront(file) { this.docFront = file },
    onDocBack(file) { this.docBack = file },

    onExtracaoFinalizada({ extracted, meta }) {
      this.extractedJson = extracted
      this.concessionariaNaoIdentificada = (meta && meta.concessionariaNaoIdentificada) || ''
      this.marcarConcluida(2)
      this.etapaAtual = 3
    },

    voltar() {
      if (this.etapaAtual > 1) this.etapaAtual--
    },

    avancarSimples() {
      this.marcarConcluida(this.etapaAtual)
      this.etapaAtual++
    },

    async enviar() {
      this.enviando = true
      try {
        // 1. Submit dos dados pessoais + instalação
        const payload = {
          website: this.honeypot, // honeypot
          person_type:    this.form.person_type,
          name:           this.form.nome.trim(),
          person_number:  (this.form.person_number || '').trim(),
          email:          this.form.email.trim(),
          cellphone:      (this.form.telefone || '').trim(),
          nationality:    this.form.nacionalidade || 'Brasileira',
          marital_status: this.form.estado_civil || 'solteiro',
          birth_date:     this.form.person_type === 'pf' ? this.form.data_nascimento : undefined,
          document_type:  this.form.tipo_documento || 'cnh',

          code:        this.form.numero_instalacao,
          zipcode:     (this.form.cep || '').trim(),
          address:     this.form.logradouro,
          number:      this.form.numero,
          complement:  this.form.complemento || '',
          city:        this.form.cidade,
          state:       (this.form.estado || '').toUpperCase(),
          distributor: this.nomeConcessionaria(),
          phase_type:  this.form.tipo_fase || '',
          kwh_avg:     this.form.kwh_avg || 0,
        }

        const extractedParaSimulacao = this.extractedJson || (this.modoManual ? {
          consumption: { consumed_kwh: parseFloat(String(this.form.kwh_avg).replace(',', '.')) || 0 },
          total_due: parseFloat(String(this.form.valor_fatura).replace(',', '.')) || 0,
          company_name: (() => { const c = CONCESSIONARIAS.find(x => String(x.id) === String(this.form.concessionaria_id)); return c ? c.nome : '' })(),
        } : null)
        const simulacao = gerarResumoSimulacao({
          extractedJson:    extractedParaSimulacao,
          concessionariaId: this.form.concessionaria_id,
          tipoFase:         this.form.tipo_fase,
        })
        if (simulacao) {
          payload.simulation_json = JSON.stringify(simulacao)
        }

        if (this.sponsor && this.sponsor.indication) {
          payload.sponsor = this.sponsor.indication
        }

        const res = await api.post('clients', payload)
        if (res.data.status !== 'success') {
          this.$toast.error(res.data.message || 'Não foi possível enviar o cadastro.')
          return
        }

        const protocol = res.data.protocol
        const clientId = res.data.lead && res.data.lead.client_id
        const installationId = res.data.lead && res.data.lead.installation_id

        // 2. Upload do documento de identidade
        if (this.docFront && clientId) {
          try {
            const fd = new FormData()
            fd.append('document_type', this.form.tipo_documento || 'cnh')
            fd.append('doc_front', this.docFront)
            if (this.docBack) fd.append('doc_back', this.docBack)
            const r = await api.post(`clients/${clientId}/documents`, fd)
            if (r.data.status !== 'success') {
              this.$toast.warning(r.data.message || 'Cadastro enviado, mas houve erro ao anexar o documento.')
            }
          } catch (e) {
            this.$toast.warning('Cadastro enviado, mas não conseguimos anexar o documento. Nossa equipe entrará em contato.')
          }
        }

        // 3. Upload do arquivo da fatura (PDF ou imagem)
        if (this.pdfFile && installationId) {
          try {
            const fd = new FormData()
            fd.append('bill_pdf', this.pdfFile)
            if (this.extractedJson) {
              fd.append('extracted_json', JSON.stringify(this.extractedJson))
            }
            const r = await api.post(`clients/${installationId}/bill`, fd)
            if (r.data.status !== 'success') {
              this.$toast.warning(r.data.message || 'Cadastro enviado, mas houve erro ao anexar a conta.')
            }
          } catch (e) {
            this.$toast.warning('Cadastro enviado, mas não conseguimos anexar a conta. Nossa equipe entrará em contato.')
          }
        } else if (this.pdfFile) {
          // Arquivo anexado mas sem instalação na resposta — avisa em vez de descartar em silêncio
          this.$toast.warning('Cadastro enviado, mas não conseguimos anexar a conta. Nossa equipe entrará em contato.')
        }

        this.$router.push({ name: 'sucesso', params: { protocol } })
      } catch (err) {
        const msg = err?.response?.data?.message || err?.message || 'Erro de comunicação. Tente novamente.'
        this.$toast.error(msg)
      } finally {
        this.enviando = false
      }
    },
  },
}
</script>

<template>
  <div class="page">
    <HeroHeader />

    <main class="container-narrow wizard-shell">
      <Stepper
        :etapas="etapas"
        :atual="etapaAtual"
        :concluidas="etapasConcluidas"
        @ir-para="irParaEtapa"
      />

      <FormCard :title="tituloEtapa" :subtitle="subtituloEtapa">
        <!-- honeypot anti-bot -->
        <input
          v-model="honeypot"
          class="honeypot"
          type="text"
          tabindex="-1"
          autocomplete="off"
          aria-hidden="true"
        />

        <EtapaVendedor
          v-if="etapaAtual === 1"
          :sponsor="sponsor"
          @confirmar="onSponsorConfirmado"
          @sem-vendedor="onSponsorIgnorado"
        />

        <EtapaPdf
          v-else-if="etapaAtual === 2"
          :form="form"
          :pdf-file="pdfFile"
          @pdf-changed="onPdfFile"
          @extracao-finalizada="onExtracaoFinalizada"
          @modo-manual="onModoManual"
        />

        <EtapaSimulacao
          v-else-if="etapaAtual === 3"
          :extracted-json="extractedJson"
          :form="form"
          :modo-manual="modoManual"
          @voltar="voltar"
          @avancar="avancarSimples"
        />

        <EtapaDadosPessoais
          v-else-if="etapaAtual === 4"
          :form="form"
          @voltar="voltar"
          @avancar="avancarSimples"
        />

        <EtapaInstalacao
          v-else-if="etapaAtual === 5"
          :form="form"
          :concessionaria-nao-identificada="concessionariaNaoIdentificada"
          @voltar="voltar"
          @avancar="avancarSimples"
        />

        <EtapaDocumento
          v-else-if="etapaAtual === 6"
          :form="form"
          :doc-front="docFront"
          :doc-back="docBack"
          @doc-front-changed="onDocFront"
          @doc-back-changed="onDocBack"
          @voltar="voltar"
          @avancar="avancarSimples"
        />

        <EtapaRevisao
          v-else-if="etapaAtual === 7"
          :form="form"
          :pdf-file="pdfFile"
          :doc-front="docFront"
          :doc-back="docBack"
          :enviando="enviando"
          @voltar="voltar"
          @enviar="enviar"
        />
      </FormCard>
    </main>

    <footer class="footer">
      © {{ new Date().getFullYear() }} Axen
    </footer>
  </div>
</template>
